import { Link } from "react-router-dom";
import SettingsIcon from "./SettingsIcon";

export type ImportSourcesSection = "imports" | "inventory" | "coverage" | "profiles";

export default function ImportSourcesNav({ active }: { active: ImportSourcesSection }) {
  return (
    <div className="flex justify-end">
      <Link to="/coverage?tab=profiles" aria-current={active === "profiles" ? "page" : undefined}
        className="inline-flex h-9 items-center gap-2 rounded-md px-3 text-sm font-medium text-slate-600 hover:bg-slate-100">
        <SettingsIcon /> Datenquellen
      </Link>
    </div>
  );
}
